import { render } from "./DocumentReportFieldSelectionQuality.vue?vue&type=template&id=bcb9e5c6&scoped=true&ts=true"
import script from "./DocumentReportFieldSelectionQuality.vue?vue&type=script&lang=ts"
export * from "./DocumentReportFieldSelectionQuality.vue?vue&type=script&lang=ts"

import "./DocumentReportFieldSelectionQuality.vue?vue&type=style&index=0&id=bcb9e5c6&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcb9e5c6"]])

export default __exports__